module.exports = __webpack_public_path__ + "static/media/how-to-choose-javascript-framework-for-project.94fbd384.md";